import isDevelopment from './isDevelopment';

const settings = {
  enablePageAnimation : !isDevelopment,
};

export default settings;